// Auto-refactored from translations.js on 2026-08-19
// Locale: zh

const zh = {
  wieMoeglich: { question: '这怎么可能？', answer: '我们重新构想了价值链。' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'STIG ROCK 之路',
    fazit: '缩短的供应链消除了最大的成本项目。',
    fazitBigPre: '由此可实现的价格优惠高达',
    fazitBigValue: '80%',
    steps: [ '矿山', '切割工坊', '认证', '终端客户' ]
  },
  nav: { language: '语言', contact: '联系方式' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: '一个独特的机会',
    subtitle: '面向未来的资产积累。',
    description: 'STIG ROCK是一个国际平台，为人们提供天然钻石、可持续财富增长以及独特社区的机会。',
    scroll: '向下滚动探索'
  },
  disclaimer: {
    overline: '法律声明',
    title: 'Disclaimer',
    paragraphs: [
      '本演示文稿仅供参考，不构成任何财务、投资或税务建议。',
      'STIG ROCK 并非金融产品，而是指作为实物资产的天然 Diamond。',
      '不保证价值增长、利润或收益。过往的表现不代表未来的结果。',
      '所有关于佣金的计算仅为示例，不构成任何保证。'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ '建基于', '结构' ],
    body: 'STIG Group 是一家国际集团，建基于清晰、责任和长期价值。每个品牌、每个项目和每项合作伙伴关系都遵循单一标准——无捷径，无例外。',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ '建基于', '结构' ],
        body: 'STIG Group 是一家国际集团，建基于清晰、责任和长期价值。每个品牌、每个项目和每项合作伙伴关系都遵循单一标准——无捷径，无例外。'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ '独家', 'Diamond 世界' ],
        body: 'STIG ROCK 是 STIG Group 的现代概念，将高品质的 GIA 认证 Diamond 与透明的结构和高端客户体验相结合。清晰的解决方案计划、专业的执行和国际化视野。'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ '国际', 'Diamond 贸易' ],
        body: 'Stig International 是 STIG Group 的一部分，专注于 GIA 认证 Diamond 的国际贸易。专注于品质、信任以及通过全球合作伙伴建立的现代贸易结构。'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ '从矿山开始', '的责任' ],
        body: 'Ethical Mines 代表着负责任的开采、可追溯的来源和无冲突 Diamond。从矿山到市场——为整个供应链提供透明度、诚信和长期责任的完整记录。'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: '钻石',
    stigDrawback: '真正的价值储存',
    overline: '可能性',
    title: '资产积累的可能性',
    subtitle: '传统途径对比。',
    items: [
      { tag: 'Trading', name: 'Forex 或 Krypto', drawback: '高度投机、不可预测、复杂' },
      { tag: 'Aktien', name: '证券交易', drawback: '波动风险、专业知识要求、时间成本' },
      { tag: 'Krypto', name: '交易', drawback: '波动性、监管风险、安全漏洞' }
    ]
  },
  chance: {
    overline: 'Diamond',
    title: '被低估的机会',
    body: '多年来，Diamond 一直是价值最稳定、最具潜力的投资形式之一，但迄今为止只有少数人利用了这一潜力。',
    callout: '通过我们的 STIG ROCK，我们首次为所有人开启了通往这些非凡机会的大门。'
  },
  wertentwicklung: {
    overline: '价值演变 1995 — 2025',
    title: '一个关于价值的故事。',
    usd: 'US-Dollar',
    usdValue: '-49%',
    diamond: 'Diamond',
    diamondValue: '+185%',
    note: '1995 — 2025 年的发展趋势'
  },
  hauptgruende: {
    overline: '主要原因',
    title: '选择 Diamond 的六个理由',
    lead: 'Diamond 是真实的实物资产，独立于货币和金融体系而存在——且几个世纪以来一直保持其价值。',
    items: [
      { n: '01', title: '危机下的价值稳定', body: '实物资产保障。独立于货币和金融体系。' },
      { n: '02', title: '卓越的流动性', body: '体积小，易于隐藏和携带。' },
      { n: '03', title: '多元化与稀缺性', body: '供应瓶颈和自然资源的限制。' },
      { n: '04', title: '长期增长', body: '自 1995 年以来增长 +185%。' },
      { n: '05', title: '透明与稀缺', body: '以 4 Cʼs 为保证：Carat, Color, Clarity, Cut。' },
      { n: '06', title: '王室资产储备', body: '即使是王室也将 Diamond 作为财富储备。' }
    ]
  },
  markt: {
    overline: '市场规模',
    title: '99 — 108 Mrd. USD',
    sub: '2025 年交易额',
    forecast: '至 ~2032 / 2034 年预测：温和增长（每年 ~4 – 5 %）下约为 140 – 168 Mrd. USD。',
    source: '来源：Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — 创新',
    title: '一项创新。全球首创。',
    body: 'STIG ROCK 是全球首个让人们在 Diamond 市场中，除了获得价值增值外，还能实现被动收入的平台。',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      '注册编号 DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — 首席执行官' },
      { name: 'Michael Lang', role: 'COO — 首席运营官' }
    ]
  },
  globalNetwork: {
    overline: '关于公司',
    titleLines: [ '国际', '架构', '清晰愿景' ],
    body: 'STIG ROCK 的成立旨在使 Diamond 市场更透明、更现代且更以客户为中心——专注于信任、安全和长期架构。'
  },
  sicherheit: {
    overline: '品质与安全',
    title: 'Gemological Institute of America',
    body: '为您的 Diamond 提供认证专业知识。GIA 以极高的精确度和多年的经验评估每一颗宝石——为我们的公司和客户提供可靠的价值评估。',
    transparency: '每颗 Diamond 均符合最高质量标准，并由知名机构检测认证。每颗宝石都是独一无二的，并配有专属证书。'
  },
  plaene: {
    overline: 'Solution Pläne (SP)',
    title: '一项独特的产品创新',
    sub: '六个分级的 Solution 计划 — 从 $1K 到 $100K+，每个月及整个期限内的折扣递增。',
    recommended: '热门',
    oneYear: '1 年',
    rowLabels: {
      delivery: '交付时间',
      price: '产品价格',
      carat: '克拉',
      monthly: '折扣 (每月)',
      totalDiscount: '折扣 (总计)',
      duration: '期限'
    },
    headers: { plan: '计划', from: '起', carat: '克拉', monthly: '折扣 / 月', total: '总折扣', duration: '期限' },
    duration: '1 年',
    footnote: '所有价格信息不具法律约束力，取决于质量、需求和当前市场发展。Solution 计划也可选择 2 年期。'
  },
  plaeneVIP: {
    overline: 'Solution Pläne + VIP-Paket',
    title: 'VIP-Paket尊享更多权益',
    sub: '将您的Solution Plan与VIP-Paket相结合，即可享受高达3%的额外价格优惠。这样可以提高您的总体折扣，为您锁定更具吸引力的尊享条件。',
    rowLabels: {
      delivery: '交付时间',
      price: '产品价格',
      carat: '克拉',
      monthly: '折扣 (每月)',
      totalDiscount: '折扣 (总计)',
      vip1: 'VIP-Paket 1 (+1%)',
      vip2: 'VIP-Paket 2 (+2%)',
      vip3: 'VIP-Paket 3 (+3%)'
    },
    footnote: '所有价格信息不具法律约束力，取决于质量、需求和当前市场发展。'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'VIP-Paket尊享更多权益',
    sub: '将您的Solution Plan与VIP-Paket相结合，即可享受高达3%的额外价格优惠。这样可以提高您的总体折扣，为您锁定更具吸引力的尊享条件。',
    options: [
      { key: 'deliver', title: 'VIP-Paket尊享更多权益', body: '以您的 DS-Plan* 价格获得 Diamond (克拉)' },
      { key: 'sellToUs', title: '回售给我们', body: '您可以按您支付的购买价格将 Diamond 回售给我们。' },
      { key: 'sellThirdParty', title: '转售第三方', body: '您可以将您的 Diamond 转售给第三方。' }
    ],
    footnote: '*DS-Plan 代表 Solution 计划。'
  },
  tradWeg: {
    overline: '传统贸易',
    title: '传统路径',
    sub: '在 Diamond 到达终端客户手中之前，通过中间商、批发商和零售商，相比矿山的 Diamond 原石价格，产生了巨大的利差。',
    steps: [
      { title: '矿山', subtitle: 'Diamond 原石' },
      { title: '中间商', subtitle: '原石采购' },
      { title: '切磨厂', subtitle: '切磨成首饰 Diamond' },
      { title: '认证', subtitle: '通过 GIA 等权威机构' },
      { title: 'Diamond 交易所', subtitle: '销售给批发商' },
      { title: '批发商', subtitle: '销售给零售商' },
      { title: '零售商', subtitle: '例如珠宝商' },
      { title: '终端客户', subtitle: '购买 Diamond' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP-Pakete',
    sub: '对您签署的所有 Solution 计划有效期为 12 个月。根据不同的 VIP-Paket：增加 +1% 至 +3% 的额外折扣',
    cardKicker: '额外 – 针对所有',
    cardKicker2: 'Solution 计划',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: '折扣转化为节省',
      body: '月度节省取代月度负担。折扣转化为节省——这正好支付了您平时每个月必须自掏腰包的项目。',
      line1Label: 'DS-Plan 起',
      line1Value: '$5.000',
      line2Label: '每月折扣',
      line2Value: '3%',
      line3Label: 'VIP-Paket 3',
      line3Value: '+3%',
      resultLabel: '每月节省',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: '如何实现的？',
    title: '我们重新思考了价值链。',
    traditionalTitle: '传统路径',
    traditionalSteps: [
      '矿山 — Diamond 原石',
      '中间商 — 采购',
      '切磨厂 — 切磨',
      '认证 (GIA)',
      'Diamond 交易所 — 批发',
      '批发商 → 零售商',
      '珠宝商 → 终端客户'
    ],
    traditionalNote: '在 Diamond 到达终端客户手中之前，通过中间商、批发商和零售商产生了巨大的贸易利差。',
    stigTitle: 'STIG ROCK 路径',
    stigSteps: [ '直接采购 — 矿山 Diamond 原石', '由我们的 Partner 进行切磨与认证', '销售给终端客户与B2B客户', '每年多达 4 个贸易周期' ],
    stigNote: '我们打破了这一循环，并将贸易利差作为折扣积分返还给客户——在 DS-Plan 期限内多达 4 个贸易周期。'
  },
  optionen: {
    overline: '您的选择',
    title: '在您的 Solution 计划到期后',
    items: [
      { title: '送货上门', body: '以您的 DS-Plan 价格获得 Diamond (克拉)。' },
      { title: '回售给我们', body: '按您支付的购买价格进行回售。' },
      { title: '转售第三方', body: '在自由市场变卖 Diamond。' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution 计划 — 独特的产品创新',
    title: '简单路径',
    steps: [
      { n: '01', icon: 'signup', title: '注册', body: '联系您的推荐人并创建一个免费账户！' },
      { n: '02', icon: 'cart', title: '购买产品', body: '仅需 $ 250,- 起' },
      { n: '03', icon: 'discount', title: '获得折扣', body: '获得每月的折扣积分。' }
    ]
  },
  business: {
    overline: '奖金类型',
    title: '最简单且最公平的方式。',
    sub: '五种奖金类型 — 助您成功建立业务。',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: '最高 3 层，从 Pearl / Ruby 等级开始。'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: '从 Sapphire 开始 — 无限深度。'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: '针对 Infinity Bonus – 最高 5 层 · 无需资格要求。'
      },
      { name: 'World Pools', icon: 'world', value: '3%', desc: '全球营业额的 3 个资金池。' },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: '以 Diamond (克拉) 形式发放的一次性奖金。'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: '对于在第 3 层以内新签署的每个 Solution 计划，您都将获得此奖金。只需极低的资格要求即可解锁各个层级。',
    total: '最高 18% Unilevel Bonus',
    levels: [
      {
        level: 'Level 1',
        value: '10%',
        qual: '从一开始',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Level 2',
        value: '5%',
        qual: '从 Pearl 级别开始',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Level 3',
        value: '3%',
        qual: '从 Ruby 级别开始',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: '从 Sapphire 级别开始，您即有资格获得我们的 Infinity Bonus 计划。您将获得 3% 奖金。随着每个级别的提升，百分比也会增加。如果您团队中的 Partner 也有相应资格，您将获得级别间的差额。',
    exampleTitle: '示例',
    exampleRows: [
      { label: '您是 Blue Diamond', value: '12%' },
      { label: '您的 Partner 是 Sapphire', value: '3%' }
    ],
    exampleResult: { label: '您的 Infinity Bonus', value: '9%' },
    totalNote: '您团队中签署的所有 Solution 计划最高可获得 24% 的 Infinity Bonus — 无限深度。',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: '通过这项奖金，您可以从团队的成功中获益。您将从 Partner 的 Infinity Bonus 中获得 5% 的 Matching Bonus — 最高可达团队的第 5 层级。',
    note: '针对团队中所有的 Infinity Bonus 支付 – 最高至第 5 层。从一开始 – 无需资格要求。',
    levels: [
      { level: 'Level 1', value: '5%' },
      { level: 'Level 2', value: '5%' },
      { level: 'Level 3', value: '5%' },
      { level: 'Level 4', value: '5%' },
      { level: 'Level 5', value: '5%' }
    ],
    totalPrefix: '总计最高',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '全球营业额的 3% 被平均分配到 3 个不同的资金池中。通过达到特定的级别，您有资格参与每个资金池。',
    forever: '一旦达成 – 永久参与分红！',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: '从 Blue Diamond 开始' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: '从 Purple Diamond 开始' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: '从 Double Diamond Elite 开始' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: '总计',
    totalValue: '3%',
    totalSuffix: '全球营业额'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: '从 Diamond 级别开始，您将获得 Rang Bonus。该奖金以 Diamond (克拉) 的形式支付。这属于一次性奖金。',
    highlight: 'Diamond (克拉) 总价值达',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · 级别等级',
    title: '级别等级',
    sub: '为了达到相应的级别等级，历史总成交额 (HG) 至关重要。从 Sapphire 级别开始，成交额必须分布在多个团队中。要达到 Ruby 或更高级别，您至少需要两名签署了 Solution 计划的直接 Partner。',
    forever: '一旦达成 – 永久确认！',
    footnote: 'HV = 历史总成交额。',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 名直接 Partner', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: '与我们共同腾飞',
    title: '最佳时机就是现在。',
    body: '这一商业模式树立了新标准，并集成了长期可持续业务的所有成功因素。立即注册，选择您的 Solution 计划，抓住这一难得的商业机会。',
    hint: '请咨询邀请您参加此次演示的人员——他拥有您的注册链接。',
    formName: '姓名',
    formEmail: '电子邮箱',
    formPhone: '电话',
    formSubmit: '联系我们',
    success: '非常感谢 — 我们将谨慎地亲自与您联系。',
    callCta: '拨打电话',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: '法律说明 & 免责声明',
    disclaimer: '本演示文稿仅供参考，不构成任何财务、投资或税务建议。STIG ROCK 并非金融产品，而是指作为实物资产的天然 Diamond。不保证价值增长、利润或收益。过往的表现不代表未来的结果。所有关于佣金的计算仅为示例，不构成任何保证。内容保留更改权利 — 非官方翻译。',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. 保留所有权利。',
    version: '版本: DS-12-2025 V3'
  },
  misc: { next: '下一章节' }
};

export default zh;
